export const dbTabs2 = {
  ageRules: {
    heading: "Gästeregeln",
    headHint:
      "Legen Sie fest, wer als Kleinkind, Kind oder Erwachsener zählt und wie diese auf die Kapazität {scope} angerechnet werden. Standardmäßig belegen Kleinkinder keinen Platz und werden nicht berechnet.",
    scopeHotel: "jedes Zimmers",
    scopeApartment: "der Unterkunft",
    loading: "Regeln werden geladen…",
    emptyHotel: "Für dieses Hotel sind keine Zimmer eingerichtet.",
    capacityChipTitle: "Zimmerkapazität (in Kapazität festgelegt)",
    slots: "{count} Platz | {count} Plätze",
    badgeCustom: "Individuell",
    badgeStandard: "Standard",
    applyAgeRules: "Altersregeln anwenden",
    masterSubHotel: "Individuelle Regeln für Kleinkinder, Kinder und Kapazität dieses Zimmers.",
    masterSubApartment: "Individuelle Regeln für Kleinkinder, Kinder und Kapazität dieser Unterkunft.",
    standardNote:
      "Standardverhalten: Kleinkinder zählen nicht zur Kapazität und werden nicht berechnet.",
    capacityLabel: "Kapazität",
    capacityGuestsNote:
      'Gast · in "Kapazität" festgelegt; diese Regeln passen nur an, wer zählt | Gäste · in "Kapazität" festgelegt; diese Regeln passen nur an, wer zählt',
    infantUpTo: "Kleinkinder sind bis",
    years: "Jahre",
    childToAdult: "Ein Kind gilt als Erwachsener ab",
    maxInfants: "Maximale Anzahl Kleinkinder",
    perBooking: "pro Buchung",
    infantsOccupy: "Kleinkinder belegen einen Platz",
    infantsCharged: "Kleinkinder werden berechnet",
    childrenCount: "Kinder zählen als Gast",
    ageLegend:
      "Kleinkind: unter {infant} Jahren · Kind: {infant}–{childTo} Jahre · Erwachsener: ab {adult} Jahren.",
    listingCapacity: "Kapazität des Inserats",
    listingCapacityHint: 'In "Kapazität" festgelegt und mit "Belegung" geteilt.',
    thisAccommodation: "Diese Unterkunft",
    loadError: "Die Gästeregeln konnten nicht geladen werden.",
    saveSuccess: "Gästeregeln erfolgreich gespeichert.",
    saveError: "Die Gästeregeln konnten nicht gespeichert werden.",
  },
  globalPayments: {
    title: "Globale Zahlungen (Apartments/Villen)",
    pill: "Global",
    desc: "Diese Einstellung gilt für alle Apartment-/Villen-Unterkünfte des Benutzers.",
    loading: "Einstellungen werden geladen…",
    paymentType: "Zahlungsart",
    onArrivalLabel: "Zahlung bei Ankunft",
    onArrivalDesc: "Der Gast bucht und zahlt direkt bei der Ankunft.",
    onlineLabel: "Online-Zahlung",
    onlineDesc: "Der Gast zahlt online beim Abschluss der Buchung.",
    savedAtUserLevel: "Auf Benutzerebene für Apartments/Villen gespeichert.",
    globalDiscount: "Globaler Rabatt",
    enableGlobalDiscount: "Globalen Rabatt aktivieren",
    discountType: "Rabattart",
    percentageLabel: "Prozentsatz",
    percentageDesc: "Rabatt anteilig zur Gesamtsumme.",
    fixedLabel: "Fest",
    fixedDesc: "Fester Betrag, der abgezogen wird.",
    valueTitle: "Wert",
    phPercentage: "z. B. 10",
    phFixed: "z. B. 15.00",
    helpPercentage: "Bis zu 100 %. Wird auf die Gesamtsumme angewendet.",
    helpFixed: "Es wird ein fester Betrag in {currency} abgezogen.",
    previewTitle: "Vorschau",
    previewPercentage: "Es wird ein globaler Rabatt von {percent} % angewendet.",
    previewFixed: "Es wird ein globaler Rabatt von {amount} angewendet.",
    appliesAllDirect: "Gilt für alle Direktbuchungen von Apartments/Villen.",
    saveSuccess: "Globale Zahlungen gespeichert.",
    saveError: "Die globalen Zahlungen konnten nicht gespeichert werden.",
  },
  payments: {
    loading: "Einstellungen werden geladen…",
    q02Title: "Wann zahlt der Gast?",
    savingBadge: "Wird gespeichert…",
    payOnArrivalName: "Zahlung bei Ankunft",
    payOnArrivalHint: "Der Gast bucht und zahlt direkt bei der Ankunft.",
    payOnlineName: "Online-Zahlung",
    payOnlineHint: "Der Gast zahlt online beim Abschluss der Buchung.",
    q03Title: "Zeit zum Bezahlen",
    onlineOnlyBadge: "Nur Online-Zahlung",
    holdDesc:
      "Der Kalender wird gesperrt, während der Gast die Zahlung abschließt.<br>Zahlt er nicht innerhalb der eingestellten Zeit, <strong>wird die Verfügbarkeit automatisch freigegeben</strong>.",
    unitMin: "Min.",
    unitHour: "Stunde",
    unitHours: "Stunden",
    q04Title: "Teilzahlung",
    partialTitle: "Bei der Buchung nur einen Teil zahlen lassen",
    partialOnDesc:
      "<strong>An.</strong> Der Gast kann jetzt <strong>{percent} %</strong> zahlen und den Rest vor der Ankunft (oder alles auf einmal).",
    partialOffDesc:
      "<strong>Aus.</strong> Der Gast zahlt bei der Buchung den <strong>Gesamtbetrag</strong>.",
    blockTitle: "Der Rest wird in der Unterkunft gezahlt",
    blockOnDesc:
      "<strong>An.</strong> Der Gast zahlt online <strong>nur {percent} %</strong>; der Rest wird <strong>bei der Ankunft</strong> beglichen (er kann nicht alles online zahlen).",
    blockOffDesc:
      "<strong>Aus.</strong> Der Gast kann wählen, ob er {percent} % oder den Gesamtbetrag online zahlt.",
    q05Title: "Erinnerung an den Restbetrag",
    reminderTitle: "Erinnerung zur Zahlung des offenen Betrags senden",
    reminderOnDesc:
      "<strong>An.</strong> <strong>{when}</strong> der Ankunft (gegen 09:00 Uhr Ortszeit der Unterkunft) erhält der Gast per <strong>WhatsApp und E-Mail</strong> einen Link zur Zahlung des offenen Betrags.",
    reminderOffDesc:
      "<strong>Aus.</strong> Der Gast erhält vor der Ankunft keine Erinnerung, den Restbetrag online zu zahlen.",
    daysBefore: "{count} Tag vorher | {count} Tage vorher",
    reminderDaysLabel: "Tage vor der Ankunft",
    reminderHint:
      "Wird einmal gesendet und nur an Gäste mit offenem Betrag. Wird der Rest in der Unterkunft gezahlt, wird sie nicht gesendet.",
    approveTitle: "Buchungen freigeben",
    approveCardTitle: "Jede Buchung vor der Bestätigung freigeben",
    approveOnDesc:
      "<strong>An.</strong> Jede Buchung bleibt <strong>bis zu Ihrer Freigabe offen</strong>: Sie erhalten eine Benachrichtigung und entscheiden, ob Sie sie annehmen oder ablehnen. Sie wird erst bestätigt, wenn Sie sie freigeben.",
    approveOffDesc:
      "<strong>Aus.</strong> Buchungen <strong>bestätigen sich selbst</strong>, sobald die Zahlung abgeschlossen ist. Aktivieren Sie die Option, wenn Sie jede Anfrage lieber selbst prüfen und freigeben.",
    saveSuccess: "Gespeichert.",
    saveError: "Die Änderungen konnten nicht gespeichert werden.",
  },
  unitConfig: {
    descByRoom: "Beschreibung pro Zimmer",
    descByRoomHint:
      "Jedes Zimmer hat seine eigene Beschreibung und seine eigene Sichtbarkeit bei Direktbuchungen.",
    loadingRooms: "Zimmer werden geladen…",
    emptyHotel: "Für dieses Hotel sind keine Zimmer eingerichtet.",
    visible: "Sichtbar",
    hidden: "Verborgen",
    roomDescPlaceholder: "Beschreiben Sie {name} (Betten, Ausstattung, Aussicht…)",
    savingDesc: "Wird gespeichert…",
    autosaveHint: "Wird automatisch gespeichert, wenn Sie das Feld verlassen.",
    loadingProperty: "Daten der Unterkunft werden geladen…",
    loadErrorProperty: "Die Einstellungen dieser Unterkunft konnten nicht geladen werden.",
    amenitiesByRoom: "Ausstattung pro Zimmer",
    amenitiesByRoomHint:
      "Jedes Zimmer kann eine andere Ausstattung bieten. Direktbuchung und KI-Agent nutzen die des Zimmers, das dem Gast zugewiesen ist.",
    amenitiesCount: "{count} Ausstattungsmerkmal | {count} Ausstattungsmerkmale",
    noAmenities: "Keine Ausstattung",
    titleDescription: "Beschreibung der Unterkunft",
    titleServices: "Ausstattung und Annehmlichkeiten",
    subtitleDescription:
      "Bearbeiten Sie die Beschreibung, die Gäste auf Ihrer Seite für Direktbuchungen sehen.",
    subtitleServices: "Markiere, was diese Unterkunft bietet, und lade Fotos hoch.",
  },
};
